import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import React from "react";
import { Trans, useTranslation } from "react-i18next";

import commonCss from "../../import_skills_modal.module.scss";
import css from "./import_success_page.module.scss";

export const ImportSuccessPage = (): JSX.Element => {
  const { t } = useTranslation("skillsManagement", { keyPrefix: "header.modals.import.upload" });

  return (
    <div className={commonCss.uploadFlowContainer}>
      <Icon name="check" color="palettePrimary0" className={css.checkIcon} />
      <Typography variant="h2" className={css.title} noMargin>
        {t("CSVImportSuccessful")}
      </Typography>
      <Typography variant="bodyRegular" noMargin>
        {t("processDescriptionLine1")}
      </Typography>
      <Typography variant="bodyRegular" noMargin>
        <Trans t={t} i18nKey="processDescriptionLine2" components={[<b key="0" />]} />
      </Typography>
    </div>
  );
};
